module.exports = __webpack_public_path__ + "static/media/icon-replace.16e5b485.svg";